/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";

import { firestore } from "../../firebase/config";
// import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { getDateInFormat } from "../utilities/Utils";
import GetReferenceDetails from "../GetReferenceDetails";
import DonationReportDetails from "./ReportDetails";
import { useHistory } from "react-router-dom";
import { TiArrowBack } from "react-icons/ti";
import "./DateRangeDonationReport.css";
import {
  getDocs,
  doc,
  collection,
  getDoc,
  query,
  where,
  collectionGroup,
} from "firebase/firestore";
const columnData = [
  {
    name: "Donor Id",
    selector: (row) => row.donorId,
  },
  {
    name: "Donor Name",
    selector: (row) => row.donorName,
  },
  {
    name: "Committment Id",
    selector: (row) => row.donationId,
  },

  {
    name: "Committment Date",
    selector: (row) => row.donationDate,
  },
  {
    name: "Amount",
    selector: (row) => row.amount,
  },
  {
    name: "Bank",
    selector: (row) => row.bank,
  },
  {
    name: "Bank Reference",
    selector: (row) => row.bankRef,
  },
  {
    name: "Bank Reference Date",
    selector: (row) => row.bankRefDate,
  },
  {
    name: "Mode",
    selector: (row) => row.mode,
  },
  {
    name: "On Record",
    selector: (row) => row.onRecord,
  },
  {
    name: "Reference",
    selector: (row) => row.collectedBy,
  },
  {
    name: "To Trust",
    selector: (row) => row.trust,
  },
];
function MissedCommmittmentReport() {
  const [isLoading, setIsLoading] = useState(false);
  const [donationDetails, setDonationDetails] = useState(null);
  const [foundNoRecord, setFoundNoRecord] = useState(false);
  const [totalDonationAmount, setTotalDonationAmount] = useState(0);

  const history = useHistory();

  const [exportObj, setExportObject] = useState(null);

  /**
   * Retrieves the full name of a donor based on the provided reference.
   * @param {string} ref - The reference to the donor document.
   * @returns {Promise<string|null>} - A promise that resolves with the donor's full name or null if the document doesn't exist.
   */
  async function getDonorName(ref) {
    try {
      const collectionDonor = collection(firestore, "donors");
      const docRef = doc(collectionDonor, ref);
      const snapShot = await getDoc(docRef);

      if (snapShot.exists()) {
        return snapShot.data().fullName;
      } else {
        return null; // Return null if the document doesn't exist
      }
    } catch (e) {
      console.log(`Error in MissedCommittmentReport.jsx getDonorName: ${e}`);
      console.log(e);
      return null;
    }
  }

  const prepareExportObject = async (donationArray) => {
    const newArray = [];
    for (const dataObjEach of donationArray) {
      const newObj = {};
      let donorId = dataObjEach.donorId;
      let donorName = await getDonorName(donorId);

      if (donorName !== null) dataObjEach.donorName = donorName;
      if (dataObjEach.collectedByOrig !== "Self") {
        let collectedById = dataObjEach.collectedByOrig;
        let donorCollecorName = await getDonorName(collectedById);

        if (donorCollecorName !== null)
          dataObjEach.collectedBy = donorCollecorName;
      }

      for (const key in dataObjEach) {
        if (key !== "collectedByOrig") {
          newObj[key] = dataObjEach[key];
        }
      }
      newArray.push(newObj);
    }
    setExportObject(newArray);
  };
  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);

      setDonationDetails(null);
      setFoundNoRecord(false);
      let toDate = new Date();
      toDate.setHours(23);

      try {
        const q = query(
          collectionGroup(firestore, "donations"),
          where("date", "<=", toDate),
          where("type", "==", "Commitment")
        );

        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          let donationArray = [];
          querySnapshot.forEach((donation) => {
            let donorId = donation.ref.parent.parent.id;

            setTotalDonationAmount(
              (prevAmount) =>
                parseInt(prevAmount) + parseInt(donation.data().amount)
            );

            donationArray.push({
              donationId: donation.id,

              donorName: <GetReferenceDetails refId={donorId} needLink={true} />,
              amount: donation.data().amount,
              donationDate: getDateInFormat(
                donation.data().date.toDate().toString()
              ),
              bank: donation.data().bank,
              bankRef: donation.data().bankRef,
              bankRefDate:
                donation.data().bankRefDate !== undefined &&
                (donation.data().bankRefDate !== null) &
                  (donation.data().bankRefDate !== "")
                  ? getDateInFormat(
                      donation.data().bankRefDate.toDate().toString()
                    )
                  : "",
              trust: donation.data().trust,
              mode: donation.data().mode,
              donorId: donorId,
              onRecord: donation.data().onRecord ? "Yes" : "No",
              collectedByOrig: donation.data().collectedBy,
              collectedBy:
                donation.data().collectedBy === "Self" ? (
                  donation.data().collectedBy
                ) : (
                  <GetReferenceDetails refId={donation.data().collectedBy} />
                ),
            });
          }); //End of forEach function
          setDonationDetails(donationArray);
          prepareExportObject(donationArray);
        } else {
          setFoundNoRecord(true);
        } // end of if (!querySnapshot.empty) - else
      } catch (error) {
        console.error("Error fetching data:", error);
        alert("Failed to fetch report data. Please check your network connection or permissions.");
      }

      setIsLoading(false);
    }

    fetchData();
  }, []);

  const handleBackButton = (e) => {
    history.push("/donorreporthome");
    e.preventDefault();
  };

  const formClass = `${
    isLoading
      ? "card border-top-0 rounded-0 loading"
      : "card border-top-0 rounded-0"
  }`;
  const paginationComponentOptions = { selectAllRowsItem: true };
  return (
    <>
      <div className="card p-1 mb-1">
        <button
          className="btn btn-link"
          id="backButton"
          onClick={handleBackButton}
        >
          <TiArrowBack />
          Back to Report Home Page
        </button>
        <div className="justify-content-center d-flex">
          <h2>Missed Committment Report</h2>
        </div>
      </div>

      <div className={formClass}>
        <div className="card-body py-2 justify-content-center d-flex">
          <div className="card-title font-weight-bold m-0">
            {donationDetails !== null
              ? `Report`
              : foundNoRecord
              ? `No Record Found`
              : ``}
          </div>
        </div>

        {donationDetails !== null && donationDetails.length > 0 && (
          <>
            <div className="card-body py-2 justify-content-center d-flex">
              No of records: {donationDetails.length}
            </div>
            <div className="card-body py-2 justify-content-center d-flex">
              Total Donation Amount: {totalDonationAmount}
            </div>
            <div className="card-body py-2 justify-content-center d-flex">
              {/* <ReactHTMLTableToExcel
                id="table-xls-success"
                className="btn btn-info"
                table="DateRangeDonationReport"
                filename="DateRangeDonationReport"
                sheet="DateRangeDonationReport"
                buttonText="Download as XLS"
              /> */}
            </div>
            <DonationReportDetails
              data={donationDetails}
              columns={columnData}
              keyField={"donationId"}
              pagination={true}
              paginationComponentOptions={paginationComponentOptions}
              filename="MissedCommitmentsReport"
              exportObject={exportObj}
            />
          </>
        )}
      </div>
    </>
  );
}

export default MissedCommmittmentReport;
